import { Box } from "@mui/material";
import { type SxProps, type Theme } from "@mui/material/styles";

import NotificationShadow from "../../components/notification-shadow/notification-shadow";
import { RequireAuth } from "../../hooks/use-auth";

const styles = {
  content: { p: 3 },
} satisfies Record<string, SxProps<Theme>>;

/**
 * Route page for the notification engine shadow-comparison visualization.
 * Gates access behind `RequireAuth` and renders the tool in a padded content
 * area, matching the notification-cutover page.
 */
const NotificationShadowPage = () => {
  return (
    <RequireAuth>
      <Box sx={styles.content}>
        <NotificationShadow />
      </Box>
    </RequireAuth>
  );
};

export default NotificationShadowPage;
